//商品発注書 新規作成画面
import React, { useEffect } from 'react';
import { Button, Snackbar } from '@material-ui/core';
import { useForm, UseFormReturn } from 'react-hook-form';
import { TLedger, TLedgerPictur } from '../../types/Ledger';
import { PictureList } from '../../components/ledger/pictureList/PictureList';
import { AddField } from '../../components/ledger/addField/AddField';
import _ from 'lodash';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { addPicturesState } from '../../GlobalState';

type Tprops = {
  defaultValues: TLedger;
  changeLoggedInData: (newData: string) => void;
  photoLedgerId?: number;
};
export const Ledger: React.FC<Tprops> = (props: Tprops) => {
  const { defaultValues, changeLoggedInData, photoLedgerId } = props;

  const history = useHistory();

  const methods: UseFormReturn<TLedger, any> = useForm({ defaultValues });
  const {
    setValue,
    getValues,
    handleSubmit,
    watch,
    register,
    formState: { errors }
  } = methods;

  // 一括追加する写真達（左側に追加するために選択された写真達）
  const [, setAddPictures] = useRecoilState<TLedgerPictur[]>(addPicturesState);

  useEffect(() => {
    setAddPictures([]);
  }, []);

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Button
          style={{
            minWidth: 90,
            marginRight: 15,
            color: '#758283',
            backgroundColor: '#F5F5F5',
            margin: 10
          }}
          variant='contained'
          color='secondary'
          onClick={() => history.goBack()}
          startIcon={<ArrowBackIcon />}
        >
          戻る
        </Button>
      </div>
      <div style={{ display: 'flex' }}>
        <PictureList
          register={register}
          setValue={setValue}
          handleSubmit={handleSubmit}
          getValues={getValues}
          watch={watch}
          photoLedgerId={photoLedgerId}
          errors={errors}
          changeLoggedInData={changeLoggedInData}
        />
        <AddField setValue={setValue} getValues={getValues} watch={watch} />
      </div>
    </>
  );
};
